<div class="p-5">

    <div class="text-center">

        <img src="assets/loader.gif" style="width: 60px;"/>
        <h4 class="op-title" i18n>Placing order.... please wait..</h4>
        <p class="op-message" style="color: #777" >{{opmessage}}</p>
    </div>


</div>
